import React, { useEffect, useState } from 'react';
import axios from 'axios';

import PdfSummary from './PdfSummary';
import PdfExportsByTool from './PdfExportsByTool';
import PdfTopUsers from './PdfTopUsers';

const PdfDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({});

  useEffect(() => {
    const getPdfExportStats = async () => {
      setLoading(true);
      setStats({});
      try {
        const response = await axios({
          method: 'GET',
          url: '/api/v1/admin/getPdfExportStats',
        });
        setStats(response.data.data);
      } catch (err) {
        console.log('Error->', err?.response?.data?.message || err?.message);
      }
      setLoading(false);
    };
    getPdfExportStats();
  }, []);

  return (
    <div className="adminDashboard">
      <h1>PDF Dashboard</h1>
      <div className="adminDashboardContainer">
        <div className="pdfDashboardLayout">
          <div className="pdfDashboardSidebar">
            <PdfSummary loading={loading} stats={stats} />
          </div>
          <div className="pdfDashboardTables">
            <div className="pdfDashboardTableSection">
              <div className="pdfDashboardTableTitle">Exports by Tool</div>
              <PdfExportsByTool loading={loading} stats={stats} />
            </div>
            <div className="pdfDashboardTableSection">
              <div className="pdfDashboardTableTitle">Top 10 Users</div>
              <PdfTopUsers loading={loading} stats={stats} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfDashboard;
